import { STRING } from '../../../../utils/component-validations';
import { or } from 'ember-truth-helpers';
import FlexRow from '../../layout/flex/row.gjs';
import Super from '../base.gjs';
import styles from './no-results.module.scss';

const METADATA = {
  component: 'Spds::Core::Menu::NoResults',
  description: 'Displays a no results found message within a menu.',
  meta: {
    text: {
      type: STRING,
      description:
        'The text to display when there are no results. Defaults to "No matching results".',
      required: false,
    },
  },
  name: 'Menu No Results',
  resources: {
    github:
      'https://github.com/simplepractice/ember-simplepractice/tree/staging/addon/src/components/spds/core/menu/no-results.gjs',
  },
};

export default class SpdsCoreMenuNoResults extends Super {
  static metadata = this.setMetadata(METADATA);
  baseClass = 'spds-menu-no-results';
  styles = styles;

  <template>
    <FlexRow
      @content={{or @text "No matching results"}}
      class={{this.classes}}
      data-test-spds-menu-no-results
      {{this.validateArguments}}
    />
  </template>
}

export const SPDS_CORE_MENU_NO_RESULTS_METADATA = SpdsCoreMenuNoResults.metadata;
